import React from 'react';
import Tooltip from '@omilia/tooltip';
import { Field } from 'redux-form';
import Toggler from 'components/Toggler';

import {
  StyledContainer,
  StyledLabel,
  StyledXpackConstraintsContainer,
  StyledXpackConstraintsLabel,
  StyledXpackConstraintsSetsTipContent,
  StyledInfoIcon,
  togglerFieldStyles,
} from './styled';

const ConstraintsConfig = () => (
  <StyledContainer data-test="constraints-configuration-area">
    <StyledLabel data-test="xpack-constraints-configuration-label">
      CONSTRAINTS CONFIGURATION
    </StyledLabel>

    <StyledXpackConstraintsContainer>
      <StyledXpackConstraintsLabel data-test="xpack-constraint-sets">
        xPack Constraint Sets:
      </StyledXpackConstraintsLabel>

      <Tooltip
        content={
          <StyledXpackConstraintsSetsTipContent>
            Disable xPack{"'"}s Constraint Sets in case you want to only use
            your own.
          </StyledXpackConstraintsSetsTipContent>
        }
        placement="bottom"
      >
        <StyledInfoIcon data-test="xpack-constraint-sets-info" tabIndex="-1" />
      </Tooltip>

      <Field
        component={Toggler}
        css={togglerFieldStyles}
        label="Active"
        name="xpackConstraintSetsAreActive"
      />
    </StyledXpackConstraintsContainer>
  </StyledContainer>
);

export default ConstraintsConfig;
